module.exports = __webpack_public_path__ + "img/6.f480e791.jpg";